import { RESET_ORDERS } from '../types';

function resetOrders() {
  return {
    type: RESET_ORDERS,
  };
}

export default resetOrders;
